import React, { JSX } from "react";
import { useSelector } from "react-redux";

export type FooterProps = {
  content?: JSX.Element[] | JSX.Element | string;
  children?: JSX.Element[] | JSX.Element | string;
  companyPrimaryColor?: string;
};

function Footer ({ content, children }: FooterProps) {
  const companyPrimaryColor = useSelector((state: any) => state.user.companyPrimaryColor);
  const primaryColor = companyPrimaryColor || "#304EA1";

  return (
    <div
      className="flex-shrink-0 bg-card border-t"
      style={{ borderTopColor: `${primaryColor}20` }}
    >
      <div className="border-t border-border" />
      <div className="flex justify-around items-center text-[8px] py-0.5 text-muted-foreground bg-card border-t border-border font-['Segoe_UI',sans-serif]">
        {content || children}
      </div>
    </div>
  );
}

export default Footer;
